import { ISelectConfig } from './typings';

const config: ISelectConfig = {
  data: {},
  title: '',
  grid: undefined,
  autoFocus: false,
  search: undefined,
  alwaysLoad: false,
  needDropdown: true,
  isAutoSelection: false,
  textFieldName: 'text',
  valueFieldName: 'id',
  multiSelect: false,
  pagination: undefined,
  textTokenSeparator: '、',
  vaueleTokenSeparator: ',',
  tokenSeparators: [',', '、'],
  modifyMode: undefined,
  placeholder: undefined,
  displayMode: undefined,
  disabledMode: undefined,
  disabledControl: undefined,
};

export default config;
